import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureRef, trackRefVisit } from "@/lib/referral";
import { applyOg } from "@/lib/og";

const HANDLE_RE = /^[a-z0-9][a-z0-9_-]{1,28}[a-z0-9]$/;
const OWN_CARD = ["/watch", "/partners", "/kids", "/admin"];

// Listens for ?ref=PROMOTER_ID and credits page views while the 30-day window is active.
// Kids hub is never credited (kids video pages are also rejected server-side).
export const ReferralTracker = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (pathname.startsWith("/admin") || pathname.startsWith("/kids")) return;
    captureRef(search).then(() => trackRefVisit(pathname));
  }, [pathname, search]);

  // Personalized absolute share card for ?ref= links (captured by the crawler prerender).
  useEffect(() => {
    const ref = (new URLSearchParams(search).get("ref") || "").trim().toLowerCase();
    if (!HANDLE_RE.test(ref) || OWN_CARD.some((p) => pathname.startsWith(p))) return;
    const origin = window.location.origin;
    return applyOg({
      title: `Watch Free Movies on ReelVault - Invited by ${ref}`,
      image: `${origin}/api/r/${ref}/card.jpg`,
      url: `${origin}${pathname}?ref=${ref}`,
    });
  }, [pathname, search]);
  return null;
};
